import { render, staticRenderFns } from "./ReviewListPaginated.vue?vue&type=template&id=02f4d779&scoped=true&lang=html&"
import script from "./ReviewListPaginated.vue?vue&type=script&lang=js&"
export * from "./ReviewListPaginated.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListPaginated.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewListPaginated.vue?vue&type=style&index=1&id=02f4d779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4d779",
  null
  
)

component.options.__file = "ReviewListPaginated.vue"
export default component.exports